export default {
  methods: {
    $_saveFilter(filter, name = this.$route.name) {
      sessionStorage.setItem(name, JSON.stringify(filter))
    },
    $_getFilter(name = this.$route.name) {
      return JSON.parse(sessionStorage.getItem(name))
    },
  },
}
